<template>
  <div class="row m-0 mt-4">
    <div class="col-12 px-0 pl-lg-3 pr-lg-0 px-xl-3">
      <div class="row m-0 align-items-center cursor" @click="goBack">
        <div class="col-auto pr-1">
          <ios-arrow-back-icon />
        </div>
        <div class="col-auto p-0 mb-1">
          Back to Shop
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-9 mb-3 px-0 pl-lg-3 pr-lg-0 px-xl-3" v-if="cartItemList.length > 0">
      <div class="row m-0">
        <div class="col-12 mb-3" v-if="cartItemList.length > 0 && shopDetails.shipping">
          <div class="card px-3 pt-3">
            <h3> Shipping Method </h3>
            <div class="form-group">
              <radio v-for="method in shopDetails.shipping.shippingMethods" v-model="orderDetails.shippingMethod" :key="method" :val="method">{{method}}</radio>
              <div v-if="orderDetails.shippingMethod === 'Collection'" class="mt-2">
                Please collect from: <h4>{{ shopDetails.shipping.address | formatAddress }}</h4>
              </div>
              <div v-if="orderDetails.shippingMethod === 'Delivery' || orderDetails.shippingMethod === 'Courier'" class="mt-2">
                <transition name="fade">
                  <div v-if="isDeliveryNotification.show" class="error_text bold" :class="{'hoods_color': isDeliveryNotification.class === 'success'}">{{isDeliveryNotification.message}}</div>
                </transition>
                <form autocomplete="off">
                  <vue-google-autocomplete
                    id="map"
                    ref="shippingAddressACT"
                    classname="form-control"
                    placeholder="Enter the delivery address"
                    v-model="savedShippingAddress"
                    v-on:placechanged="getAddressData"
                    v-on:keyup="noAddress"
                    country="za">
                  </vue-google-autocomplete>
                </form>
                <div class="form-group mt-2" v-if="cantFindAddress">
                  <input
                    type="text"
                    name="shippingSuburb"
                    id="shippingSuburb"
                    class="form-control"
                    placeholder="Suburb"
                    v-model="orderDetails.shippingAddress.sublocality"
                  />
                </div>
                <div class="form-group mt-2" v-if="cantFindAddress">
                  <input
                    type="text"
                    name="shippingCode"
                    id="shippingCode"
                    class="form-control"
                    placeholder="Postal Code"
                    v-model="orderDetails.shippingAddress.postal_code"
                  />
                </div>
                <div class="form-group mt-2" v-if="orderDetails.shippingAddress">
                  <input
                    type="text"
                    name="shippingExtra"
                    id="shippingExtra"
                    class="form-control"
                    placeholder="Apt number, floor or building"
                    v-model="orderDetails.shippingExtra"
                  />
                </div>
                <div v-if="orderDetails.shippingMethod === 'Delivery'">
                <h5 class="pt-3">Select Delivery Date</h5>
                 <select v-model="orderDetails.deliveryDate" class="form-control hiddenSelect">
                  <option v-for="ddate in deliveryDates" :key="ddate" :value="ddate">{{ ddate | deldate }}</option>
                </select>
                </div>
                <!-- <radio v-for="ddate in deliveryDates" v-model="orderDetails.deliveryDate" :key="ddate" :val="ddate">{{ ddate | deldate }}</radio> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="cartItemList.length > 0">
          <div class="card">
            <transition-group name="list-shopping-cart">
              <app-cart-item
                v-for="cartItem in cartItemList"
                :cartItem="cartItem"
                :key="cartItem.id"
              ></app-cart-item>
            </transition-group>
          </div>
        </div>
        <div class="col-12 mb-3 mt-3">
          <div class="card px-3 pt-3">
            <h3> Add Billing Address </h3>
            <div class="form-group" v-if="orderDetails.shippingMethod === 'Delivery' || orderDetails.shippingMethod === 'Courier'">
              <checkbox :val="true" v-model="orderDetails.sameAddress" name="billingAddress">Same as Delivery Address</checkbox>
            </div>
            <div class="form-group" v-if="(orderDetails.shippingMethod === 'Delivery' || orderDetails.shippingMethod === 'Courier') && !orderDetails.sameAddress">
              <vue-google-autocomplete
                id="map2"
                :ref="orderDetails.billingAddress"
                classname="form-control"
                placeholder="Enter your billing address"
                v-on:placechanged="getAddressDataBilling"
                country="za"
              >
              </vue-google-autocomplete>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-3 pr-lg-0" v-if="cartItemList.length > 0">
      <div class="card p-3 mb-3">
        <h3>Notes</h3>
        <div class="form-group mt-1">
          <textarea id="orderNotes" name="orderNotes" class="form-control w-100" rows="4" placeholder="e.g This is a gift for..." v-model="orderDetails.notes"></textarea>
        </div>
      </div>
      <div class="card p-3">
        <h3>Payment Details</h3>
        <div class="form-group mt-1" v-if="shopDetails.payment">
          <radio v-for="method in shopDetails.payment.paymentMethods" v-model="orderDetails.paymentMethod" :key="method" :val="method">{{ method | formatPaymentMethod }}</radio>
        </div>
        <div class="row m-0 ">
          <div class="col-12 p-0 mt-2" v-if="(orderDetails.shippingMethod === 'Delivery' || orderDetails.shippingMethod === 'Courier') && orderDetails.shippingAddress">
            <h5>Delivery R {{ deliveryFee }}</h5>
          </div>
          <div class="col-12 p-0 mt-2 mb-3">
            <h2>Total R {{ totalCost }}</h2>
          </div>
          <div class="col-12 p-0 mb-2">
            <button class="btn btn-outline w-100" @click="checkout">
              <span class="text-nowrap" id="checkoutButton">Checkout </span>
            </button>
            <transition name="fade">
              <div v-if="isNotification.show" class="error_text text-center mt-1 bold" :class="{'hoods_color': isNotification.class === 'success'}">{{isNotification.message}}</div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 pt-5" v-else>
      <center><h1>No items in your cart</h1>
      <router-link :to="`${shopDetails.domain}/store`" class="btn btn-primary">Back </router-link></center>
    </div>
    <transition name="fade">
      <eft v-if="isEFTPopup" @close="closeEFT" :orderNumber="currentOrderNumber" />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getDistance } from '@/utils/dist'
import { getCourierFee } from '@/utils/fastway'
import CartItem from '@/components/cart/CartItem.vue'
export default {
  components: {
    appCartItem: CartItem,
    Radio: () => import('@/components/common/Radio.vue'),
    VueGoogleAutocomplete: () => import('@/components/common/VueGoogleAutocomplete.vue'),
    Checkbox: () => import('@/components/common/Checkbox.vue'),
    Eft: () => import('@/components/payment/EFTPopup.vue')
  },
  data () {
    return {
      isEFTPopup: false,
      savedShippingAddress: '',
      deliveryFee: 0,
      cantFindAddress: false,
      deliveryFeeCalculated: false,
      isNotification: {
        message: '',
        class: '',
        show: true
      },
      isDeliveryNotification: {
        message: '',
        class: '',
        show: true
      },
      orderDetails: {
        shippingAddress: '',
        marketplace: 'nicarela',
        shippingExtra: '',
        billingAddress: '',
        shippingMethod: '',
        paymentMethod: '',
        sameAddress: true,
        deliveryFee: 0,
        distance: 0,
        notes: ''
      },
      shop_url: process.env.NODE_ENV === 'production' ? `https://${window.location.host}` : 'https://chilibites.thehoods.app/',
      user_id: '',
      payment_method: 'cc',
      signature: ''
    }
  },
  metaInfo () {
    return {
      title: 'Cart Page'
    }
  },
  computed: {
    ...mapGetters([
      'cartItemList',
      'isLoggedIn',
      'products',
      'currentUser',
      'cartValue',
      'currentOrder',
      'shopDetails',
      'orders',
      'shopId'
    ]),
    currentOrderNumber () {
      return this.orders.find(order => order['.key'] === this.currentOrder).orderNumber
    },
    deliveryDates () {
      const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 12, 0, 0)
      console.log(today)
      let dates = []
      let i = 0
      if (typeof this.shopDetails.shipping.delivery.deliveryLeadTime !== 'undefined' && Number(this.shopDetails.shipping.delivery.deliveryLeadTime)) {
        i = Number(this.shopDetails.shipping.delivery.deliveryLeadTime)
      }
      if ((typeof this.shopDetails.shipping.delivery.deliveryCutOffTime !== 'undefined' && new Date().getHours() >= Number(this.shopDetails.shipping.delivery.deliveryCutOffTime)) || new Date().getHours() >= 14) {
        i += 1
      }
      while ((dates.length < 10) && (i < 20)) {
        let checkDate = new Date(today)
        checkDate.setDate(today.getDate() + i)
        if (this.shopDetails.shipping.delivery.includeDays && this.shopDetails.shipping.delivery.includeDays.includes(checkDate.getDay() + 1)) {
          if (!this.shopDetails.shipping.delivery.excludeDates || !this.shopDetails.shipping.delivery.excludeDates.includes(checkDate.getTime())) {
            dates.push(checkDate.getTime())
          }
        }
        i += 1
      }
      return dates
    },
    totalCost () {
      if (this.deliveryFee > 0) {
        return this.deliveryFee + this.cartValue
      } else {
        return this.cartValue
      }
    },
    cartItemsForAnalytics () {
      let ret = []
      this.cartItemList.forEach((item) => {
        ret.push({ item_id: item.id, item_name: item.title, item_category: item.category, price: item.price })
      })
      return ret
    }
  },
  mounted () {
    if (typeof this.shopDetails !== 'undefined' && this.shopDetails.shipping && this.shopDetails.shipping.shippingMethods && this.shopDetails.shipping.shippingMethods.length === 1) {
      this.orderDetails.shippingMethod = this.shopDetails.shipping.shippingMethods[0]
    }
    if (typeof this.shopDetails !== 'undefined' && this.shopDetails.payment && this.shopDetails.payment.paymentMethods && this.shopDetails.payment.paymentMethods.length === 1) {
      this.orderDetails.paymentMethod = this.shopDetails.payment.paymentMethods[0]
    }
    if (this.cartItemList.length) {
      this.$analytics.logEvent('begin_checkout', { currency: 'ZAR', value: this.cartValue, items: [this.cartItemsForAnalytics] })
    }
    this.populateAddress()
  },
  watch: {
    orderDetails: {
      handler () {
        this.populateAddress()
        this.calculateDeliveryFee()
      },
      deep: true
    },
    cartItemList: {
      handler () {
        this.calculateDeliveryFee()
      },
      deep: true
    },
    currentUser () {
      this.populateAddress()
      this.calculateDeliveryFee()
    }
  },
  methods: {
    ...mapActions([
      // 'addMessage',
      'saveToTransaction',
      'clearCart',
      'addPaymentDetails'
    ]),
    populateAddress () {
      if (this.currentUser && (this.orderDetails.shippingMethod === 'Delivery' || this.orderDetails.shippingMethod === 'Courier') && !this.orderDetails.shippingAddress && this.currentUser.deliveryAddress) {
        this.orderDetails.shippingAddress = this.currentUser.deliveryAddress
        this.savedShippingAddress = this.$options.filters.formatAddress(this.currentUser.deliveryAddress)
        this.checkDistanceFromStore()
      }
    },
    calculateDeliveryFee () {
      if (this.shopDetails.shipping.delivery.freeDeliveryAmount && this.cartValue >= this.shopDetails.shipping.delivery.freeDeliveryAmount) {
        this.deliveryFee = 0
        this.deliveryFeeCalculated = true
      } else if (this.orderDetails.shippingMethod === 'Delivery') {
        if (this.shopDetails.shipping.delivery.deliveryFreeRadiusKm && this.orderDetails.distance <= this.shopDetails.shipping.delivery.deliveryFreeRadiusKm) {
          this.deliveryFee = 0
          this.deliveryFeeCalculated = true
        } else if (this.orderDetails.shippingMethod === 'Delivery' && this.orderDetails.shippingAddress !== '' && this.orderDetails.distance !== 0) {
          this.deliveryFee = parseInt(this.orderDetails.distance * this.shopDetails.shipping.delivery.deliveryCostPerKm)
          this.deliveryFeeCalculated = true
        }
      } else if (this.orderDetails.shippingMethod === 'Courier') { // && this.orderDetails.shippingAddress.postal_code && this.orderDetails.shippingAddress.sublocality
        this.deliveryFee = this.shopDetails.shipping.courier.courierFixed
        this.deliveryFeeCalculated = true
      }
    },
    async calculateCourierFee () {
      if (this.orderDetails.shippingAddress && this.orderDetails.shippingAddress.sublocality && this.orderDetails.shippingAddress.postal_code) {
        let weight = 0
        let multiplier = 1
        this.cartItemList.forEach((item) => {
          weight += Number(item.weight) * item.quantity
        })
        if (!weight) {
          weight = 15
        }
        if (weight > 30) {
          multiplier = Math.ceil(weight / 30)
          weight = 30
        }
        let responseObject = await getCourierFee('VEE', this.orderDetails.shippingAddress.sublocality, this.orderDetails.shippingAddress.postal_code, weight)
        this.orderDetails.shippingAddress.route = document.getElementById('map').value
        this.deliveryFee = Math.round(Number(responseObject.data.result.cheapest_service[0].totalprice_normal) * multiplier)
        this.deliveryFeeCalculated = true
      } else {
        this.deliveryFeeCalculated = false
      }
    },
    getAddressData (addressData, placeResultData, id) {
      this.orderDetails.shippingAddress = addressData
      console.log('found address')
      this.cantFindAddress = false
      this.checkDistanceFromStore()
    },
    noAddress () {
      console.log('no address')
      this.cantFindAddress = true
      this.orderDetails.shippingAddress = {}
    },
    getAddressDataBilling (addressData, placeResultData, id) {
      this.orderDetails.billingAddress = addressData
    },
    checkDistanceFromStore () {
      if (this.orderDetails.shippingMethod === 'Delivery' && typeof this.shopDetails.shipping.address !== 'undefined') {
        this.orderDetails.distance = getDistance(this.shopDetails.shipping.address.latitude, this.shopDetails.shipping.address.longitude, this.orderDetails.shippingAddress.latitude, this.orderDetails.shippingAddress.longitude)
        console.log(this.orderDetails, this.shopDetails.shipping.delivery.deliveryRadiusKm)
        if (this.orderDetails.distance > Number(this.shopDetails.shipping.delivery.deliveryRadiusKm)) {
          this.isDeliveryNotification.message = 'The address you entered is too far, please enter a closer address'
          this.isDeliveryNotification.class = 'error'
          this.isDeliveryNotification.show = true
          setTimeout(() => {
            this.isDeliveryNotification.show = false
          }, 3000)
          // this.addMessage({
          //   messageClass: 'danger',
          //   message: 'The destination is too far, delivery unavailable'
          // })
          this.orderDetails.shippingAddress = ''
          this.$refs['shippingAddressACT'].clear()
          this.$refs['shippingAddressACT'].focus()
          return false
        }
      }
      return true
    },
    checkValidCart (itemList, prodList) {
      let isValid = true
      let message = ''
      itemList.map((item) => {
        for (let prodIdx = 0; prodIdx < prodList.length; prodIdx++) {
          if (prodList[prodIdx].id === item.id) {
            if (prodList[prodIdx].quantity !== '' && prodList[prodIdx].quantity < item.quantity) {
              message = `Only ${prodList[prodIdx].quantity} ${item.title} available in stock`
              isValid = false
              return
            }
            break
          }
        }
      })
      if (isValid && !this.checkDistanceFromStore()) {
        isValid = false
        message = 'Too far, delivery unavailable'
      } else if ((this.orderDetails.shippingMethod === 'Delivery' || this.orderDetails.shippingMethod === 'Courier') && !this.deliveryFeeCalculated) {
        isValid = false
        this.$refs.shippingAddressACT.focus()
        message = 'Please enter a valid delivery address'
      } else if (typeof this.shopDetails.shipping.delivery.minAmountDelivery !== 'undefined' && this.cartValue < this.shopDetails.shipping.delivery.minAmountDelivery) {
        isValid = false
        message = 'The minimum order amount for delivery is R' + this.shopDetails.shipping.delivery.minAmountDelivery
      } else if (this.orderDetails.paymentMethod.length < 1) {
        isValid = false
        message = 'Please select a payment method'
      } else if (this.orderDetails.shippingMethod.length < 1) {
        isValid = false
        message = 'Please select a shiping method'
      }
      return {
        isValid,
        message
      }
    },
    payment () {
      const yoco = new window.YocoSDK({
        publicKey: process.env.NODE_ENV === 'production' ? this.shopDetails.payment.yoco.publicKey : 'pk_test_7cd9ad03BGZAkjK0e8d4'
      })
      yoco.showPopup({
        amountInCents: this.totalCost * 100,
        currency: 'ZAR',
        name: `${this.shopDetails.name}`,
        description: `Order from ${this.shopDetails.name}`,
        callback: this.paymentCallback,
        customer: {
          email: this.currentUser.email,
          firstName: this.currentUser.firstname,
          lastName: this.currentUser.lastname,
          phone: this.currentUser.phone
        },
        metadata: {
          billNote: `order ${this.currentOrder}`,
          orderId: this.currentOrder,
          customerId: this.currentUser.uid,
          productType: 'theHoods'
        }
      })
    },
    paymentCallback (result) {
      console.log(result)
      if (result.errorType) {
        // set order payment to error
        console.log('payment error')
        // redirect to order?
      } else {
        this.addPaymentDetails({
          uid: this.currentUser.uid,
          token: result,
          orderId: this.currentOrder,
          amountInCents: this.totalCost * 100
        })
        this.clearCart()
        this.$router.push(`/order/${this.currentOrder}`)
      }
    },
    checkout () {
      if (this.isLoggedIn) {
        if (!this.cartItemList || this.cartItemList.length === 0) {
          this.isNotification.message = 'Your cart is empty!'
          this.isNotification.class = 'error'
          this.isNotification.show = true
          setTimeout(() => {
            this.isNotification.show = false
          }, 3000)
          // this.addMessage({
          //   messageClass: 'warning',
          //   message: 'Your cart is empty!'
          // })
          return
        }
        let { isValid, message } = this.checkValidCart(
          this.cartItemList,
          this.products
        )
        if (isValid) {
          this.$set(this.orderDetails, 'deliveryFee', this.deliveryFee)
          this.$set(this.orderDetails, 'totalCost', this.totalCost)
          this.saveToTransaction({
            cartItemList: this.cartItemList,
            uid: this.currentUser.uid,
            orderDetails: this.orderDetails
          }).then((tid) => {
            this.isNotification.message = 'Your order has been successfully placed!'
            this.isNotification.class = 'success'
            this.isNotification.show = true
            setTimeout(() => {
              this.isNotification.show = false
            }, 3000)
            // this.addMessage({
            //   messageClass: 'success',
            //   message: 'Your order has been successfully placed!'
            // })
            this.$analytics.logEvent('purchase', { transaction_id: tid, currency: 'ZAR', value: this.totalCost, shipping: this.deliveryFee, items: [this.cartItemsForAnalytics] })
            if (this.orderDetails.paymentMethod === 'Credit Card') {
              this.payment()
            } else if (this.orderDetails.paymentMethod === 'EFT') {
              this.isEFTPopup = true
            } else {
              this.$router.push(`/order/${this.currentOrder}`)
              this.clearCart()
            }
          })
        } else {
          this.isNotification.message = message
          this.isNotification.class = 'error'
          this.isNotification.show = true
          setTimeout(() => {
            this.isNotification.show = false
          }, 3000)
          // this.addMessage({
          //   messageClass: 'danger',
          //   message: message
          // })
        }
      } else {
        this.$emit('login')
        // this.addMessage({
        //   messageClass: 'warning',
        //   message: 'Please login to checkout'
        // })
      }
    },
    closeEFT () {
      this.isEFTPopup = false
      this.$router.push(`/order/${this.currentOrder}`)
      this.clearCart()
    },
    goBack () {
      this.$router.push(`/${this.shopId}/store`)
    }
  }
}
</script>

<style lang="scss" scoped>
.full_popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--dark-color-08);
  z-index: 9999;
}
.list-shopping-cart-leave-active {
  transition: all 0.4s;
}

.list-shopping-cart-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.table-sm {
  font-size: 0.875rem;
  ::v-deep h4 {
    font-size: 1.25rem;
  }
}
#hideMe {
  -moz-animation: cssAnimation 0s ease-in 5s forwards;
  /* Firefox */
  -webkit-animation: cssAnimation 0s ease-in 5s forwards;
  /* Safari and Chrome */
  -o-animation: cssAnimation 0s ease-in 5s forwards;
  /* Opera */
  animation: cssAnimation 0s ease-in 5s forwards;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
@keyframes cssAnimation {
  to {
    width:0;
    height:0;
    overflow:hidden;
  }
}
@-webkit-keyframes cssAnimation {
  to {
    width:0;
    height:0;
    visibility:hidden;
  }
}
</style>
